import EditUserFormContainer from './edit-agent-form-container';

export default EditUserFormContainer;
